import { qnPrimary } from '../themes/_palette';

export const MuiMenuItem = {
    styleOverrides: {
        root: {
            margin: '8px 0',
            borderRadius: 8,
            '&.MuiMenuItem-root': {
                minHeight: '40px',
                lineBreak: 'anywhere',
                fontSize: '0.875rem',
                color: 'var(--mui-palette-primary-textColor)'
            },
            '&.Mui-selected:hover': {
                backgroundColor: 'var(--mui-palette-secondary-main)',
            },
            "&:hover, &:focus, &.Mui-selected": {
                backgroundColor: 'var(--mui-palette-secondary-main)',
                
            }
        }
    }
}
